(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async function (event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-yloma-cookie-settings]');
  if (!button) return;
  const error = button.closest('[data-yloma-clarity-disclosure]').querySelector('[data-yloma-cookie-error]');
  error.hidden = true;
  button.disabled = true;
  try {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Cookie preferences unavailable');
    await window.privacyBanner.showPreferences();
  } catch (exception) {
    error.hidden = false;
  } finally {
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const searchLink = event.target.closest('.yloma-header-mobile-search');
    if (searchLink) {
      const drawer = searchLink.closest('header-sidebar');
      const search = document.getElementById(searchLink.dataset.searchTarget);
      if (drawer && search) {
        event.preventDefault();
        await drawer.hide();
        search.show();
      }
      return;
    }
    const sidebarAnchor = event.target.closest('.yloma-reference-sidebar [data-yloma-sidebar-anchor]');
    if (sidebarAnchor) sidebarAnchor.closest('header-sidebar').hide();
    const closeButton = event.target.closest('.yloma-reference-header [data-yloma-menu-close]');
    if (!closeButton) return;
    const disclosure = closeButton.closest('mega-menu-disclosure');
    if (!disclosure) return;
    disclosure.close();
    disclosure.summaryElement.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yloma-breed-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yloma-breed-finder')) {
    customElements.define('yloma-breed-finder', class extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onAlternative = this.onAlternative.bind(this);
      }
      connectedCallback() {
        this.form = this.querySelector('[data-finder-form]');
        this.cards = [...this.querySelectorAll('[data-finder-product]')];
        this.profiles = [...this.querySelector('[data-breed-profiles]').content.querySelectorAll('[data-breed]')];
        this.form.addEventListener('submit', this.onSubmit);
        this.form.addEventListener('reset', this.onReset);
        this.addEventListener('click', this.onAlternative);
        this.form.hidden = false;
        this.showResults('all', 'all');
      }
      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
        this.form?.removeEventListener('reset', this.onReset);
        this.removeEventListener('click', this.onAlternative);
      }
      onSubmit(event) {
        event.preventDefault();
        if (!this.form.checkValidity()) return this.form.reportValidity();
        const breed = this.form.elements.namedItem('breed');
        const profile = this.profiles.find(item => item.dataset.breed === breed.value);
        const group = profile?.dataset.group || 'all';
        const selectedBreed = this.querySelector('[data-selected-breed]');
        selectedBreed.textContent = breed.selectedOptions[0].textContent;
        selectedBreed.hidden = false;
        const measurements = this.getMeasurements();
        this.showResults(group, this.form.elements.namedItem('category').value, measurements);
        this.showMeasurements(measurements);
        const heading = this.querySelector('.yloma-finder__results-heading');
        heading.focus({ preventScroll: true });
        if (window.matchMedia('(max-width: 999px)').matches) {
          heading.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }
      onReset() {
        queueMicrotask(() => {
          this.querySelector('[data-selected-breed]').hidden = true;
          this.querySelector('[data-measurement-result]').hidden = true;
          this.showResults('all', 'all');
        });
      }
      onAlternative(event) {
        if (!event.target.closest('[data-explore-beds]')) return;
        this.form.elements.namedItem('category').value = 'bed';
        this.form.requestSubmit();
      }
      showResults(group, category, measurements = {}) {
        const limit = Number(this.dataset.limit) || 3;
        const measured = Boolean(measurements.length || measurements.width || measurements.height);
        const orderedCards = measured && group !== 'all' ? this.cards.map((card, index) => ({ card, index, priority: card.dataset.groups.split(' ').includes(group) ? 0 : 1 })).sort((a, b) => a.priority - b.priority || a.index - b.index).map(item => item.card) : this.cards;
        this.querySelector('[data-finder-cards]').append(...orderedCards);
        let visible = 0;
        orderedCards.forEach(card => {
          const groups = card.dataset.groups.split(' ');
          const matches = (measured || group === 'all' || groups.includes(group)) && (category === 'all' || card.dataset.category === category);
          const variant = measured && matches ? this.findComparableVariant(card, measurements) : null;
          const show = matches && (!measured || variant) && visible < limit;
          card.hidden = !show;
          if (show) {
            visible += 1;
            this.displayVariant(card, variant);
          }
        });
        this.querySelector('[data-empty-state]').hidden = visible > 0;
        this.querySelector('[data-explore-beds]').hidden = visible > 0 || group !== 'large' || category !== 'house';
        this.querySelector('[data-result-status]').textContent = this.dataset.resultTemplate.replace('__count__', String(visible));
      }
      getMeasurements() {
        return Object.fromEntries(['length', 'width', 'height'].map(axis => [axis, Number(this.form.elements.namedItem(`pet_${axis}`).value) || 0]));
      }
      findComparableVariant(card, measurements) {
        const variants = [...card.querySelector('[data-available-variants]').content.querySelectorAll('[data-variant-id]')];
        const candidates = variants.filter(variant => {
          const data = variant.dataset;
          if (data.available !== 'true' || data.manualOnly !== 'false') return false;
          const width = Number(data.interiorWidth);
          const depth = Number(data.interiorDepth);
          const height = Number(data.interiorHeight);
          if (measurements.length || measurements.width) {
            if (!width || !depth) return false;
            if (measurements.length && measurements.width) {
              const orientationOne = measurements.length <= width && measurements.width <= depth;
              const orientationTwo = measurements.length <= depth && measurements.width <= width;
              if (!orientationOne && !orientationTwo) return false;
            } else if (Math.max(measurements.length || 0, measurements.width || 0) > Math.max(width, depth)) return false;
          }
          if ((card.dataset.category === 'house' || data.category === 'house') && measurements.height && (!height || measurements.height > height)) return false;
          return true;
        });
        candidates.sort((a, b) => Number(a.dataset.interiorWidth) * Number(a.dataset.interiorDepth) - Number(b.dataset.interiorWidth) * Number(b.dataset.interiorDepth));
        return candidates[0] || null;
      }
      displayVariant(card, variant) {
        const data = variant?.dataset;
        const url = data?.url || card.dataset.defaultUrl;
        const price = data?.price || card.dataset.defaultPrice;
        const imageSource = data?.image || card.dataset.defaultImage;
        card.querySelector('.yloma-finder__price').textContent = price;
        card.querySelectorAll('[data-product-link]').forEach(link => { link.href = url; });
        card.querySelector('[data-details-link]').href = `${url}#yloma-product-details-${card.dataset.productId}`;
        const image = card.querySelector('.yloma-finder__image');
        if (image && imageSource) {
          image.removeAttribute('srcset');
          image.src = imageSource;
          image.alt = data?.alt || card.dataset.defaultAlt;
        }
        const variantLabel = card.querySelector('[data-variant-result]');
        variantLabel.hidden = !data?.variantTitle;
        if (data?.variantTitle) variantLabel.textContent = this.dataset.variantTemplate.replace('__variant__', data.variantTitle);
        const interior = card.querySelector('[data-interior-result]');
        interior.hidden = !data;
        const opening = card.querySelector('[data-opening-result]');
        opening.hidden = true;
        if (!data) return;
        const format = new Intl.NumberFormat(document.documentElement.lang || 'el');
        const replaceDimensions = template => template.replace('__width__', format.format(Number(data.interiorWidth))).replace('__depth__', format.format(Number(data.interiorDepth))).replace('__height__', format.format(Number(data.interiorHeight)));
        interior.textContent = replaceDimensions(card.dataset.category === 'house' ? this.dataset.interiorHouseTemplate : this.dataset.interiorBedTemplate);
        let openingText = '';
        if (data.openingDiameter) openingText = this.dataset.openingDiameterTemplate.replace('__diameter__', format.format(Number(data.openingDiameter)));
        else if (data.openingWidth && data.openingHeight) openingText = this.dataset.openingTemplate.replace('__width__', format.format(Number(data.openingWidth))).replace('__height__', format.format(Number(data.openingHeight)));
        else if (data.openingHeight) openingText = this.dataset.openingHeightTemplate.replace('__height__', format.format(Number(data.openingHeight)));
        if (openingText) {
          opening.textContent = openingText;
          opening.hidden = false;
        }
      }
      showMeasurements(measurements) {
        const result = this.querySelector('[data-measurement-result]');
        result.hidden = !measurements.length && !measurements.width && !measurements.height;
        if (result.hidden) return;
        const format = new Intl.NumberFormat(document.documentElement.lang || 'el');
        result.textContent = ['length', 'width', 'height'].reduce((text, axis) => text.replace(`__${axis}__`, measurements[axis] ? format.format(measurements[axis]) : '—'), this.dataset.measurementTemplate);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yloma-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yloma-hero')) {
    customElements.define('yloma-hero', class extends HTMLElement {
      async connectedCallback() {
        await customElements.whenDefined('effect-carousel');
        if (!this.isConnected || this._controller) return;
        this._controller = new AbortController();
        this._carousel = this.querySelector('effect-carousel');
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._connection = navigator.connection;
        this._rotationRequested = this.dataset.autoplay === 'true' && !this._motion.matches && !this._connection?.saveData;
        this._visible = false;
        this._hovering = false;
        this._motionPaused = false;
        this._carousel.player?.stop();
        const options = { signal:this._controller.signal };
        this.querySelectorAll('[hidden]').forEach(element => element.hidden = false);
        const motionToggle = this.querySelector('[data-motion-toggle]');
        if (motionToggle && !this._carousel.player) motionToggle.hidden = true;
        this.addEventListener('click', event => this._onClick(event), options);
        this.addEventListener('focusin', event => { if (!event.target.closest('[data-motion-toggle]')) this._stopRotation(); }, options);
        this.addEventListener('pointerdown', event => { if (!event.target.closest('[data-motion-toggle]')) this._stopRotation(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this._hovering = true; this._syncRotation(); } }, options);
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this._hovering = false; this._syncRotation(); } }, options);
        this._carousel.addEventListener('keydown', event => {
          if (event.target !== this._carousel || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this._stopRotation();
          this._goTo(this._carousel.selectedIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, { ...options,capture:true });
        for (const gesture of ['swipeleft','swiperight']) {
          this._carousel.addEventListener(gesture, event => {
            this._stopRotation();
            if (this._motion.matches) {
              event.stopImmediatePropagation();
              this._goTo(this._carousel.selectedIndex + (gesture === 'swipeleft' ? 1 : -1));
            }
          }, { ...options,capture:true });
        }
        this._carousel.addEventListener('carousel:change', event => this._onChange(event.detail), options);
        this._carousel.addEventListener('carousel:settle', () => { this._syncRotation(); this._playActiveVideo(); }, options);
        this.querySelectorAll('video').forEach(video => {
          video.addEventListener('playing', () => {
            const slide = video.closest('.yloma-hero__slide');
            if (slide !== this._carousel.selectedCell || !this._visible || document.hidden) { video.pause(); return; }
            slide.classList.add('has-video-frame','is-video-playing');
            this._syncVideoButton(video);
            this._syncMotionButton();
          }, options);
          video.addEventListener('pause', () => { video.closest('.yloma-hero__slide').classList.remove('is-video-playing'); this._syncVideoButton(video); this._syncMotionButton(); }, options);
          video.addEventListener('error', () => { video.closest('.yloma-hero__slide').classList.remove('has-video-frame','is-video-playing'); this.querySelector('[data-hero-status]').textContent = this.dataset.videoError; }, options);
        });
        document.addEventListener('visibilitychange', () => {
          this._syncRotation();
          if (document.hidden) this._pauseVideos();
          else this._playActiveVideo();
        }, options);
        const preferenceChanged = () => {
          if (this._motion.matches || this._connection?.saveData) { this._motionPaused = true; this._stopRotation(); this._pauseVideos(); }
        };
        this._motion.addEventListener('change', preferenceChanged, options);
        this._connection?.addEventListener('change', preferenceChanged, options);
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries[0].isIntersecting;
          this._syncRotation();
          if (this._visible) this._playActiveVideo();
          else this._pauseVideos();
        }, { threshold:.1 });
        this._observer.observe(this);
        this._onChange({ index:this._carousel.selectedIndex,cell:this._carousel.selectedCell });
        this._syncMotionButton();
      }
      disconnectedCallback() {
        this._controller?.abort();
        this._observer?.disconnect();
        this._carousel?.player?.stop();
        this._pauseVideos();
        this._controller = null;
      }
      _stopRotation() {
        this._rotationRequested = false;
        this._carousel.player?.stop();
        this._syncMotionButton();
      }
      _syncRotation() {
        const canRotate = this._rotationRequested && this._visible && !this._hovering && !document.hidden;
        if (canRotate) this._carousel.player?.start();
        else this._carousel.player?.stop();
        this._syncMotionButton();
      }
      _syncMotionButton() {
        const button = this.querySelector('[data-motion-toggle]');
        if (!button) return;
        const video = this._carousel?.selectedCell?.querySelector('video');
        const playing = this._rotationRequested || Boolean(video && !video.paused);
        button.setAttribute('aria-pressed',String(playing));
        button.setAttribute('aria-label',playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }
      _syncVideoButton(video) {
        const button = video.closest('.yloma-hero__slide').querySelector('[data-video-toggle]');
        if (!button) return;
        const label = video.paused ? button.dataset.videoPlayLabel : button.dataset.videoPauseLabel;
        button.setAttribute('aria-label',label);
        button.setAttribute('aria-pressed',String(!video.paused));
        button.querySelector('[data-video-label]').textContent = label;
      }
      _pauseVideos() {
        this.querySelectorAll('video').forEach(video => video.pause());
      }
      async _playActiveVideo(explicit = false) {
        const video = this._carousel?.selectedCell?.querySelector('video');
        if (!video || !this._visible || document.hidden || !explicit && (this._motionPaused || this._motion.matches || this._connection?.saveData)) return;
        if (!video.querySelector('source[src]')) {
          video.querySelectorAll('source[data-src]').forEach(source => source.src = source.dataset.src);
          video.load();
        }
        video.muted = true;
        try { await video.play(); } catch { this._syncVideoButton(video); }
      }
      _onChange({ index,cell }) {
        this._pauseVideos();
        this._carousel.cells.forEach(slide => { slide.inert = slide !== cell; slide.setAttribute('aria-hidden',String(slide !== cell)); });
        this.querySelectorAll('[data-slide-index]').forEach(button => button.setAttribute('aria-current',String(Number(button.dataset.slideIndex) === index)));
        if (!this._rotationRequested) this.querySelector('[data-hero-status]').textContent = cell.dataset.announcement;
      }
      async _goTo(index,playFilm = false) {
        const total = this._carousel.cells.length;
        await this._carousel.select((index + total) % total,{ instant:this._motion.matches });
        if (playFilm) {
          this._carousel.selectedCell.querySelector('[data-video-toggle]')?.focus({ preventScroll:true });
          this._motionPaused = false;
          this._playActiveVideo(true);
        }
      }
      _onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-motion-toggle')) {
          const video = this._carousel.selectedCell.querySelector('video');
          const playing = this._rotationRequested || Boolean(video && !video.paused);
          this._rotationRequested = !playing;
          this._motionPaused = playing;
          this._syncRotation();
          if (playing) this._pauseVideos();
          else this._playActiveVideo(true);
        } else if (button.hasAttribute('data-slide-index')) {
          this._stopRotation();
          this._goTo(Number(button.dataset.slideIndex));
        } else if (button.hasAttribute('data-direction')) {
          this._stopRotation();
          this._goTo(this._carousel.selectedIndex + (button.dataset.direction === 'next' ? 1 : -1));
        } else if (button.hasAttribute('data-film-index')) {
          this._stopRotation();
          this._goTo(Number(button.dataset.filmIndex),true);
        } else if (button.hasAttribute('data-video-toggle')) {
          this._stopRotation();
          const video = button.closest('.yloma-hero__slide').querySelector('video');
          if (video.paused) { this._motionPaused = false; this._playActiveVideo(true); }
          else { this._motionPaused = true; video.pause(); }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yloma-payment-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yloma-announcements')) {
    customElements.define('yloma-announcements', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-announcement-slide]')];
        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.dialog = this.querySelector('dialog');
        this.toggle = this.querySelector('[data-announcement-toggle]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hovered = false;
        this.focusPaused = false;
        this.querySelectorAll('.yloma-announcements__control').forEach(button => { button.hidden = this.slides.length < 2; });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-announcement-previous]')) this.change(-1, true);
          if (event.target.closest('[data-announcement-next]')) this.change(1, true);
          if (event.target.closest('[data-announcement-toggle]')) {
            this.paused = !this.paused;
            this.focusPaused = false;
            this.sync();
          }
          if (event.target.closest('[data-announcement-details]')) {
            this.dialog.showModal();
            this.sync();
          }
          if (event.target.closest('[data-announcement-close]')) this.dialog.close();
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', () => { this.focusPaused = true; this.sync(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.sync(); } }, options);
        this.dialog?.addEventListener('close', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
        this.sync();
      }
      change(direction, manual = false) {
        this.slides[this.index].hidden = true;
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        const slide = this.slides[this.index];
        slide.hidden = false;
        if (!this.motion.matches) slide.animate([{ opacity: 0, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
        if (manual) {
          this.paused = true;
          this.querySelector('[data-announcement-status]').textContent = slide.textContent.trim();
          this.sync();
        }
      }
      sync() {
        clearInterval(this.timer);
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        if (this.slides.length > 1 && !this.paused && !this.hovered && !this.focusPaused && !this.dialog?.open && !document.hidden) {
          this.timer = setInterval(() => this.change(1), Math.max(4000, Number(this.dataset.interval) || 6000));
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yloma-product-confidence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yloma-confidence-photo')) {
    customElements.define('yloma-confidence-photo', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const imageData = this.querySelector('[data-confidence-images]');
        if (!imageData) return;
        try {
          this.variantImages = JSON.parse(imageData.textContent);
        } catch {
          return;
        }
        document.addEventListener('variant:change', (event) => {
          const formId = event.target instanceof HTMLFormElement ? event.target.getAttribute('id') || '' : '';
          if (!formId.startsWith(`product-form-main-${this.dataset.productId}-`)) return;
          const image = this.querySelector('.yloma-product-confidence__image');
          const photo = this.variantImages[String(event.detail?.variant?.id)];
          if (!image || !photo?.src) return;
          image.width = photo.width;
          image.height = photo.height;
          image.alt = photo.alt;
          image.srcset = photo.srcset;
          image.src = photo.src;
          image.closest('figure').dataset.imageKind = photo.kind;
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
